import { AiConversationPage } from './AiConversationsPage';

export default AiConversationPage;
